import script from "./MsgMaze.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsgMaze.vue?vue&type=script&setup=true&lang=ts"

import "./MsgMaze.vue?vue&type=style&index=0&id=0c107e00&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c107e00"]])

export default __exports__